export const Modules = {
    USUARIOS: 1,
    PERMISSOES: 2,
    CATEGORIAS: 3,
    PRODUTOS: 4,
    MARCAS: 5,
    PAGINAS: 6,
    SLIDES: 7,
    PEDIDOS: 8,
    RELATORIOS: 9,
    DASHBOARD: 10,
    MEDIDAS: 11,
    TABLOIDES: 12,
    BANNERS: 13,
    CORES: 14,
    VARIACOES: 15,
    CARDS_CONFIGURAVEIS: 16,
    VIDEOS: 17,
    POPUPS: 18,
    CLIENTES: 19,
    NEWSLETTER: 20,
    FUNCIONARIOS: 21,
    TIPOS_DE_FUNCIONARIO: 22,
    CONTATOS: 23,
    TRANSPORTADORAS: 24,
    REGRAS_DE_FRETE: 25,
    INTEGRACOES_DE_FRETES: 26,
    REDES_SOCIAIS: 27,
    ANALYTICS: 28,
    FILTROS_FAIXAS_DE_PRECO: 29,
    MENSAGENS_STATUS_PEDIDO: 30,
    EMPRESA: 31,
    AO_VIVO: 32,
    TABELA_DE_PRECO: 33,
    CUPONS: 34,
    ITENS_ADICIONAIS: 35,
    GRADES: 36,
    SABORES: 37,
    HORARIOS_DE_ENTREGA: 38,
    CONDICOES_DE_PAGAMENTO: 39,
    FORMAS_DE_PAGAMENTO: 40,
    TIPOS_DE_PAGAMENTO: 41,
    CONTAS_A_PAGAR: 42,
    CONTAS_A_RECEBER: 43,
    FORMULARIOS: 44,
    FERIADOS: 45,
    FORNECEDORES: 48,
    //
}
